import { render, staticRenderFns } from "./DeductionIndex.vue?vue&type=template&id=79fd09a2&scoped=true&"
import script from "./DeductionIndex.vue?vue&type=script&lang=js&"
export * from "./DeductionIndex.vue?vue&type=script&lang=js&"
import style0 from "./DeductionIndex.vue?vue&type=style&index=0&id=79fd09a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd09a2",
  null
  
)

export default component.exports